module.exports = __webpack_public_path__ + "img/pr-13.0e86acb4.png";